import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  Alert as MuiAlert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  TextField as MuiTextField,
  Grid,
  CardHeader,
  Typography,
  MenuItem,
} from "@mui/material";
import { spacing } from "@mui/system";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";
import SaveCancel from "../../../components/SaveCancel";
import useMkRadius from "../../../hooks/useMkRadius";
import MkRadiusFields from "./components/MkRadiusFields";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Card = styled(MuiCard)(spacing);

const Alert = styled(MuiAlert)(spacing);

const validationSchema = Yup.object().shape({
  nas: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  address: Yup.string().required("Required"),
  secret: Yup.string().required("Required"),
  status: Yup.string().required("Required"),
});

function EditRadius() {
  const { getMkRadius, mkRadius, updateMkRadius, isSubmitting } = useMkRadius();

  React.useEffect(() => {
    if (Object.keys(mkRadius).length !== 0) {
      console.log(mkRadius.status, "mkRadius.status");
      const initialValues = {
        radiusId: mkRadius.radiusId,
        nas: {
          value: mkRadius.nas.nasId,
          label: mkRadius.nas.nasName,
        },
        address: mkRadius.address,
        secret: mkRadius.secret,
        ppp: mkRadius.ppp,
        hotspot: mkRadius.hotspot,
        status: mkRadius.status,
      };
      reset(initialValues);
    }
  }, [mkRadius]);

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });

  const dispatch = useDispatch();

  const [status, setStatus] = useState({
    sent: false,
  });

  const [errorSubmit, setErrorSubmit] = useState({
    submit: "",
  });

  const [currentCountry, setCurrentCountry] = useState(null);
  const { state } = useLocation();
  console.log(state, "location");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;

  const onSubmit = async (data) => {
    try {
      data["nas"] = {
        nasId: data.nas.value,
        nasName: data.nas.label,
      };
      await updateMkRadius(data);
      dispatch(showSuccessSnackbar("Radius updated successfully!"));
      navigate("/mikrotik-mgnt/mk-radius/list");
      reset();
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to updata Radius"));
    }
  };

  const cancelBtn = () => {
    navigate("/mikrotik-mgnt/mk-radius/list");
  };

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Mikrotik-mgnt</Typography>
        <Typography>Mk Radius</Typography>
        <Typography>Edit</Typography>
      </Breadcrumbs>
    );
  };

  const fetchData = async () => {
    await getMkRadius(state.id);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <Card mb={6}>
          <CardHeader title={t("edit_mk_radius")} subheader={breadCrump()} />
          <CardContent>
            {status && status.sent && (
              <Alert severity="success" my={3}>
                MkRadius updated successfully!
              </Alert>
            )}

            {isSubmitting ? (
              <Box display="flex" justifyContent="center" my={6}>
                <CircularProgress />
              </Box>
            ) : (
              <form onSubmit={handleSubmit(onSubmit)}>
                <MkRadiusFields fields={validationSchema.fields} />
                <SaveCancel cancelBtn={cancelBtn} resetForm={reset} />
              </form>
            )}
          </CardContent>
        </Card>
      </FormProvider>
    </React.Fragment>
  );
}

export default EditRadius;
